export function formatNumeric(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '0'
  
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return '0'
  
  return new Intl.NumberFormat('en-US').format(num)
}

export function formatPercentage(value: number): string {
  if (!Number.isFinite(value)) return '0%'
  return `${Math.round(value)}%`
}

function formatCurrency(value: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)
}

export function sanitizeUrl(url: string): string {
  if (!url) return ''
  
  // Remove 'www.'
  let sanitized = url.replace(/www\./, '')
  
  // Remove 'http://' and 'https://'
  sanitized = sanitized.replace(/https?:\/\//, '')

  try {
    // If it's a full URL, extract just the hostname
    const urlObj = new URL(`https://${sanitized}`)
    sanitized = urlObj.hostname
  } catch (error) {
    // If URL parsing fails, return the sanitized string as is
  }

  return sanitized
}

/**
 * Format a duration in seconds to a human-readable string
 * Examples:
 *   - 45 seconds -> "45s"
 *   - 125 seconds -> "2m 5s"
 *   - 3725 seconds -> "1h 2m"
 *   - 90000 seconds -> "25h"
 */
export function formatDuration(seconds: number): string {
  if (seconds === null || seconds === undefined || isNaN(seconds)) return '0s'
  if (seconds < 0) return '0s'
  if (seconds < 60) return `${Math.round(seconds)}s`
  
  const hours = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = Math.round(seconds % 60)
  
  if (hours > 0) {
    // For long durations, show hours and minutes
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`
  }
  
  // For shorter durations, show minutes and seconds
  return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`
}